export const environment = {
  production: false,
  version:'V 1.2.1-dev',
  firebase: {
    apiKey: "AIzaSyCFM57I3S38F5s6Xq36_QuGb_tMiSDszUE",
    authDomain: "mhabits.firebaseapp.com",
    databaseURL: "https://mhabits-default-rtdb.firebaseio.com",
    projectId: "mhabits",
    storageBucket: "mhabits.firebasestorage.app",
    messagingSenderId: "16655967625",
    appId: "1:16655967625:web:59fe1f472425b732faed58",
    measurementId: "G-MMKXMJR6V5"
  }
};
